import React, { FC } from 'react';
import { useSetHttpStatus } from 'app/utils/HttpStatusState';
import { useCss } from 'app/utils/css';
import { NotFoundError } from './ErrorBoundaryPage';
import ErrorBoundaryState from './mixins/ErrorBoundaryState';
import HttpStatusPageContent from './pages/HttpStatusPageContent';
import { COLOR_PALETTE } from 'app/constants/ColorPalette';

const AppBootstrapErrorBoundary: FC = ({ children }) => {
  return (
    <ErrorBoundaryState>
      {({ error }) => {
        if (error !== undefined) {
          // If the error isn't a NotFoundError throw it up to the next error boundary
          if (!(error instanceof NotFoundError)) {
            throw error;
          }
          return <NotFoundMessage error={error} />;
        } else {
          return children;
        }
      }}
    </ErrorBoundaryState>
  );
};

function NotFoundMessage({ error }: { error: Error }) {
  useSetHttpStatus(404);
  const css = useCss();
  return (
    <div
      className={css('error-page', {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100vh',
        flexGrow: 1,
        background: COLOR_PALETTE.grey.lighter,
      })}
    >
      <div
        className={css('error-content', {
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'stretch',
          flexGrow: 1,
          margin: '0 auto',
          width: '100%',
          maxWidth: '1000px',
        })}
      >
        <HttpStatusPageContent status={404} header="Not Found" message={error.message} />
      </div>
    </div>
  );
}

export default AppBootstrapErrorBoundary;
